
const digest = '7f1396061f9899cd3ca587ed84c1052456a577c26ab57dafb41b64594aa1b50c';
const classes = {"wrapper":"_wrapper_pmj6y_1"};
const css = `._wrapper_pmj6y_1 {
  height: calc(100vh - 400px);
  max-height: 600px;
  min-height: 300px;
  overflow: hidden;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  